import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import TableCrudEnhanced from '../../components/TableCrudEnhanced';

const CurrencyTypeIndex = () => {
    const navigate = useNavigate();

    const filterConfig = useMemo(() => [
        {
            type: "text",
            name: "description",
            label: "Description",
            placeholder: "Search by description..."
        }
    ], []);

    const columns = useMemo(() => [
        { 
            title: 'Currency Type Description', 
            dataIndex: 'description', 
            key: 'description', 
            sortable: true 
        },
        { 
            title: 'Deleted', 
            dataIndex: 'isDeleted', 
            key: 'isDeleted', 
            width: 100,
            render: (value, record, index, handleToggleActive, handleToggleDeleted) => (
                <span 
                    className={`badge ${!value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleDeleted && handleToggleDeleted(record)}
                    title={`Click to ${!value ? 'delete' : 'restore'}`}
                >
                    {!value ? 'Not Deleted' : 'Deleted'}
                </span>
            )
        }
    ], []);

    const actions = useMemo(() => [
        {
            label: 'Edit',
            onClick: (record) => navigate(`/currencyType/edit/${record.currencyTypeID}`),
            type: 'primary'
        }
    ], [navigate]);

    return (
        <TableCrudEnhanced
            title="Currency Type"
            apiEndpoint="/CurrencyType/getAllPaginated"
            toggleDeletedEndpoint="/CurrencyType/toggleDeleted"
            newRoute="/currencyType/new"
            columns={columns}
            filterConfig={filterConfig}
            actions={actions}
            rowKey="currencyTypeID"
            initialPageSize={10}
            enableFilters={true}
            showAddButton={true}
        />
    );
};

export default CurrencyTypeIndex;
